// extracted by mini-css-extract-plugin
export default {"popupCallButton":"PopupCallButton_popupCallButton__tdOUv"};